/**
 * Nombre del mes del paquete mensual. Vive aparte del componente porque lo
 * usan el tab del expediente y la bandeja de Contraloría, y exportar esto
 * desde un archivo de componente rompe el fast refresh.
 *
 * En minúsculas porque casi siempre va dentro de una frase ("Documentos de
 * agosto de 2026"); donde encabeza una celda se capitaliza con CSS.
 */
const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
]

export const nombreDelMes = (month: number, year: number) =>
  `${MESES[month - 1] ?? ''} de ${year}`
